import React, { useContext, useEffect, useRef, useState } from 'react'
import GoogleMapReact from 'google-map-react'
import { REACT_APP_7NOW_ADDRESS_MAP_KEY } from 'config/environment'
import { MarkerClusterer } from '@googlemaps/markerclusterer'
import MapConstants from './MapConstants'
import { isEmpty } from 'utils/appUtils'
import { LanguageContext } from 'context/LanguageContext'
const MapComponent = ({
    selectedAddress,
    stores,
    setSelectedStore,
    selectedStore = {},
    selectedItem = {},
    pickupAddress = {},
    defaultProps,
    noOfStores,
}) => {
    const mapRef = useRef(null)
    const mapsRef = useRef(null)
    const markerRefs = useRef([])
    const markerClustererRef = useRef(null)
    const { language } = useContext(LanguageContext)

    const [center, setCenter] = useState({
        lat: !isEmpty(selectedAddress) ? parseFloat(selectedAddress?.lattitude) : null,
        lng: !isEmpty(selectedAddress) ? parseFloat(selectedAddress?.longitude) : null,
    })
    useEffect(() => {
        !isEmpty(selectedItem) &&
            setCenter({
                lat: selectedItem?.lat,
                lng: selectedItem?.lon,
            })
        updateMarkerColor(selectedItem, MapConstants.selectedMarker)
    }, [selectedItem])
    useEffect(() => {
        updateMarkers()
    }, [pickupAddress, noOfStores])

    const handleMapClick = ({ event }) => {
        event.stopPropagation()
    }

    const handleMarkerClick = (markerData, googleMarker) => {
        markerRefs.current.forEach(({ markerRef }) => {
            markerRef.setIcon(MapConstants.SVGMaker(MapConstants.defaultMarker))
        })

        googleMarker.setIcon(MapConstants.SVGMaker(MapConstants.selectedMarker))

        setCenter({
            lat: markerData?.lat,
            lng: markerData?.lon,
        })
        setSelectedStore(markerData)
    }
    const validCenter = center?.lat && center?.lng ? center : defaultProps.center
    const handleApiLoaded = (map, maps) => {
        mapRef.current = map
        mapsRef.current = maps
        updateMarkers()
    }

    const updateMarkers = () => {
        if (!mapRef.current || !mapsRef.current) return

        markerRefs.current.forEach(({ markerRef }) => markerRef.setMap(null))
        markerRefs.current = []
        if (markerClustererRef.current) {
            markerClustererRef.current.clearMarkers()
        }

        if (noOfStores === 0) return

        if (stores?.length) {
            const googleMarkers = stores.map(marker => {
                const googleMarker = new mapsRef.current.Marker({
                    position: { lat: marker.lat, lng: marker.lon },
                    map: mapRef.current,
                    icon: MapConstants.SVGMaker(
                        selectedStore?.store_id === marker.store_id ||
                            (marker.lat === center.lat && marker.lon === center.lng)
                            ? MapConstants.selectedMarker
                            : MapConstants.defaultMarker
                    ),
                    setZoom: 15,
                })
                mapRef.current.setZoom(
                    Math.max(mapRef.current.getZoom(), MapConstants.defaultZoomUnit)
                )
                markerRefs.current.push({
                    id: marker.store_id,
                    markerRef: googleMarker,
                    lat: marker.lat,
                    lon: marker.lon,
                })
                googleMarker.addListener('click', () => handleMarkerClick(marker, googleMarker))
                return googleMarker
            })

            markerClustererRef.current = new MarkerClusterer({
                map: mapRef.current,
                markers: googleMarkers,
                maxZoom: 15,
                zoomOnClick: true,
            })
        }
    }

    const updateMarkerColor = (storeDetails, color) => {
        const markerToUpdate = markerRefs.current.find(
            marker => marker.id === storeDetails?.store_id
        )
        if (markerToUpdate) {
            const googleMarker = markerToUpdate.markerRef

            const isInCluster = markerClustererRef.current.clusters.some(cluster =>
                cluster.markers.includes(googleMarker)
            )

            if (isInCluster) {
                mapRef.current.panTo(googleMarker.getPosition())
                mapRef.current.setZoom(
                    Math.max(mapRef.current.getZoom(), MapConstants.defaultZoomUnit)
                )
            }

            markerRefs.current.forEach(({ markerRef }) => {
                markerRef.setIcon(MapConstants.SVGMaker(MapConstants.defaultMarker))
            })
            markerToUpdate.markerRef.setIcon(MapConstants.SVGMaker(color))
        }
    }
    return (
        <div style={{ height: '100%', width: '100%' }}>
            <GoogleMapReact
                bootstrapURLKeys={{
                    key: REACT_APP_7NOW_ADDRESS_MAP_KEY,
                    libraries: ['places'],
                    language: language
                }}
                defaultCenter={validCenter}
                center={validCenter}
                defaultZoom={15}
                onClick={handleMapClick}
                options={{
                    clickableIcons: false,
                }}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
            ></GoogleMapReact>
        </div>
    )
}

export default MapComponent
